import React, { useMemo } from 'react'
import { SelectOption } from 'types/SelectOption'

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  option: SelectOption
  options: SelectOption[]
}

function Select({ option, options, className, ...props }: SelectProps) {
  const classNames = useMemo(() => {
    let result = 'select'
    if (className) result += ` ${className}`
    return result
  }, [className])

  return (
    <select className={classNames} value={option.value} {...props}>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  )
}

export default Select
